<template>
  <div class="container">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'

      :current='page'
      :count='count'>
      <div slot="queryParams" class="form">
        <div class="queryContainer">

          <div class="queryItem">
            <label>收款日期:</label>
            <!-- <timeStampDatePicker  class="item" clearable placeholder=" 请选择" v-model.trim='query.proceedsTime'/> -->
            <timeStampDatePicker class="item" type='daterange' placeholder=" 请选择" clearable v-model.trim='query.durationReceive' />
          </div>
          <div class="queryItem">
            <label>收款方式:</label>
            <lk-select class="item" clearable v-model.trim='query.proceedsTypeId'>
              <lk-option v-for="(item,index) in proceedsTypes" :key="index" :value='item.proceedsTypeId'>{{item.proceedsTypeName}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>付款人姓名:</label>
            <lk-input :maxlength='100' placeholder='请输入' class="item" clearable
                      v-model.trim='query.paymentUserName'></lk-input>
          </div>
          <div class="queryItem">
            <label>销售单号:</label>
            <lk-input :maxlength='100' placeholder='请输入' class="item" clearable
                      v-model.trim='query.saleOrderCode'></lk-input>
          </div>
          <div class="queryItem">
            <label>收款单单号:</label>
            <lk-input :maxlength='100' placeholder='请输入' class="item" clearable
                      v-model.trim='query.depositCode'></lk-input>
          </div>
          <!-- <div class="queryItem">
           <goodsSearchItem v-model="query.nameMix"></goodsSearchItem>
          </div> -->
        <div class="queryItem">
            <label>创建时间:</label>
            <timeStampDatePicker class="item" clearable placeholder=" 请选择" v-model.trim='query.createTime'/>
          </div>
          <div class="queryItem" v-if="roleType!==2">
            <label>门店名称:</label>
            <StoreListSelect v-model.trim='query.storeIdList' class="item"></StoreListSelect>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="btns">
          <lk-button type='primary' @click="$router.push({name:'proceedAdd'})"
                     v-if="handlePermission('proceedAdd')">+新建收款单
          </lk-button>
          <DownloadButton @on-click='handleExport' v-if="handlePermission('proceedsListDownload')"></DownloadButton>
        </div>
        <lk-table border :columns='columns' :data='tableData' class='cancelTableShadow'></lk-table>
      </div>
    </QueryFrame>
    <lk-modal v-model="showRefund" width="420">
        <p slot="header">
          <span>预收退款</span>
        </p>
        <lk-form
          :model="refundData"
          label-position="right"
          :label-width="90"
          ref="refundData"
          :rules="ruleValidate">
          <div>
            <lk-form-item label="收款单号：">
              <span>{{selectOrderNum}}</span>
            </lk-form-item>
            <lk-form-item label="退款方式：" prop="proceedsTypeId">
                <lk-select v-model="refundData.proceedsTypeId" label-in-value @on-change="handleProceedsTypeChange">
                    <lk-option v-for="item in proceedsTypeList" :value="item.proceedsTypeId" :key="item.proceedsTypeName">{{ item.proceedsTypeName }}
                    </lk-option>
                </lk-select>
            </lk-form-item>
            <lk-form-item label="退款金额：" prop="amount">
              <lk-input-number :precision="2" style="width:calc(100%)" :max="selectDeposit * 1" :min="0" placeholder='请输入' :active-change="false" v-model.trim="refundData.amount" ></lk-input-number>
            </lk-form-item>
            <lk-form-item label="退款原因：">
              <lk-input :maxlength='40' placeholder='请输入' clearable v-model.trim="refundData.reason" ></lk-input>
            </lk-form-item>
          </div>
        </lk-form>
        <div slot="footer">
          <lk-button type="primary" size="large"  @click="handleSure">确认退款</lk-button>
          <lk-button type="default" size="large"  @click="handleCancel">取消</lk-button>
        </div>
      </lk-modal>
  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import finance from '../../services/finance';
import system from '../../services/system';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import DownloadButton from '../../components/download/DownloadButton.vue';
import refundModal from './refundModal.vue';

export default {
  name: 'proceed',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame, DownloadButton, refundModal,
    // DTPModal
  },
  computed: {
    roleType() {
      return this.$store.state.user.roleType;
    },
  },
  data() {
    return {
      selectDeposit: 9999999,
      proceedsTypeList: [],
      refundData: {},
      ruleValidate: {
        proceedsTypeId: [
          {
            required: true,
            message: '请选择退款方式',
            trigger: 'blur',
          },
        ],
        amount: [
          {
            required: true,
            trigger: 'change',
            validator: this.dotTwoValidator,
          },
        ],
      },
      selectOrderNum: '',
      selectRefundId: '',
      showRefund: false,
      loading: false,
      statuslist: ['草稿', '审批中', '审批通过', '审批未通过'],
      query: {
        durationReceive: [],
      },
      proceedsTypes: [],
      columns: [
        { title: '收款单号', key: 'depositCode', minWidth: 169 },
        { title: '收款日期', key: 'proceedsTime', minWidth: 116 },
        { title: '收款单状态', key: 'depositStatus', minWidth: 116 },
        { title: '收款方式', key: 'proceedsTypeName', minWidth: 116 },
        { title: '付款人', key: 'paymentUserName', minWidth: 116 },
        { title: '联系方式', key: 'paymentUserPhone', minWidth: 116 },
        {
          title: '销售单号', key: 'saleOrderCodes', minWidth: 176,
        },
        // { title: '应收核销金额', key: 'receiveVerificationAmount', minWidth: 116 },
        { title: '收款金额', key: 'proceedsAmount', minWidth: 116 },
        { title: '已退款金额', key: 'refundAmount', minWidth: 116 },
        { title: '已核销金额', key: 'receivables', minWidth: 116 },
        { title: '退货退回金额', key: 'returnAmount', minWidth: 116 },
        { title: '剩余预收款', key: 'deposit', minWidth: 116 },
        { title: '创建人', key: 'createUserName', minWidth: 116 },
        { title: '创建时间', key: 'createTime', minWidth: 136 },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 160,
          render: (h, params) => h('div', {
            class: {
              textCenter: true,
            },
          }, [
            this.handlePermission('proceedCheck') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'proceedCheck', params: { id: params.row.id } });
                },
              },
            }, '查看') : null,
            this.handlePermission('proceedEdit') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
                disabled: params.row.allowEdit !== 1 || params.row.financeProceedsStatus === 2,
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'proceedEdit', params: { id: params.row.id } });
                },
              },
            }, '编辑') : null,
            this.handlePermission('proceedRefund') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.gotoRefund(params.index);
                },
              },
            }, '退款') : null,

          ]),
        },
      ],
      tableData: [],

    };
  },
  methods: {
    dotTwoValidator(rule, value, callback) {
      if (value > 0) {
        const temp = `${value}`;
        if (value * 1 > this.selectDeposit * 1) {
          callback(new Error('不能大于剩余预收款'));
        } else if ((temp.includes('.') && temp.split('.')[1].length <= 2)) {
          callback();
        } else if (temp.includes('.')) {
          callback(new Error('精度为小数点后两位'));
        }
        callback();
      } else {
        callback(new Error('输入值为大于0的数字'));
      }
    },
    handleSure() {
      this.refundData.financeDepositId = this.selectRefundId;
      if (!this.refundData.proceedsTypeId) {
        this.$Message.error('请选择退款方式');
        return;
      }
      if (isNaN(this.refundData.amount * 1) || this.refundData.amount == undefined || !this.refundData.amount || this.refundData.amount * 1 <= 0) {
        this.$Message.error('请输入正确的退款金额');
        return;
      }
      finance.refundMoney(this.refundData).then((res) => {
        if (res.data.status === 200) {
          this.showRefund = false;
          this.getData();
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleCancel() {
      this.showRefund = false;
    },
    handleProceedsTypeChange(item) {
      const name = this.proceedsTypeList.filter(element => element.proceedsTypeId == item.value)[0].proceedsTypeName;
      this.refundData.proceedsTypeName = name; // 退款方式名称
    },
    gotoRefund(val) {
      this.refundData = {};
      this.showRefund = true;
      this.refundData.amount = null;
      this.refundData.proceedsTypeId = this.tableData[val].proceedsTypeId;
      this.refundData.proceedsTypeName = this.tableData[val].proceedsTypeName;
      this.selectOrderNum = this.tableData[val].depositCode;
      this.selectRefundId = this.tableData[val].id;
      this.selectDeposit = this.tableData[val].deposit;
    },
    handleExport() {
      const params = utils.deepClone(this.params);
      if (params.createTime) {
        params.createTime = (new Date(params.createTime)).getTime();
      }
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      delete params.page;
      delete params.size;
      if (this.query.durationReceive.length > 0) {
        this.params.proceedsTimeStart = this.query.durationReceive[0];
        this.params.proceedsTimeEnd = this.query.durationReceive[1];
      }
      finance.financeDepositExport(params).then((res) => {
        if (res.data.error) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },

    clear() {
      this.query = {

      };
    },

    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      if (this.query.durationReceive.length > 0) {
        this.params.proceedsTimeStart = this.query.durationReceive[0];
        this.params.proceedsTimeEnd = this.query.durationReceive[1];
      }
      finance.getFinanceDepositList(this.params).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;
          this.tableData = [];
          this.count = count;
          list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.createTime = utils.formatTime(result.createTime);
            result.proceedsTime = utils.formatDate(result.proceedsTime);
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getProceedsTypes(have) {
      return new Promise((resolve) => {
        system.getStoreProceedsTypeList(have ? { status: 1 } : {}).then((res) => {
          if (res.data.status === 200) {
            resolve(res.data.data.list);
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },

  },
  created() {
    if (this.roleType !== 2) {
      this.columns.splice(1, 0, { title: '门店名称', key: 'storeName', minWidth: 116 });
    }
    this.getProceedsTypes(false).then((res) => {
      // this.proceedsTypes = res;
      this.proceedsTypes = res.filter(item => !item.proceedsTypeFlag || !item.proceedsTypeFlag === 'deposit');
      this.handleSearch(true);
      console.log('来了111');
    }).catch((err) => {
      utils.handleError(err);
    });
    this.getProceedsTypes(true).then((res) => {
      // this.proceedsTypes = res;
      this.proceedsTypeList = res.filter(item => !item.proceedsTypeFlag || !item.proceedsTypeFlag === 'deposit');
      this.handleSearch(true);
      console.log('来了222');
    }).catch((err) => {
      utils.handleError(err);
    });
  },
};
</script>
<style lang="less" scoped>
  // .form{
  //   margin-top: 16px
  // }
  .btns{
    margin-bottom: 12px;
    >*{
      margin-right: 16px
    }
  }
  .queryContainer{//样式写进公共类中
    display: flex;
    padding-bottom: 16px;
    flex-wrap: wrap;

    .queryItem{
      display: flex;
      align-items: center;
      margin-right: 32px;
      flex-wrap: wrap;
      margin-bottom: 15px;
      .item{
        display: inline-block;
        width: 256px
      }
    }
  }
  @media print {
    .print-area {
      display: block;
    }
    .page-break {
      page-break-after: always;
    }
  }
  @media screen {
    .print-area {
      display: none;
    }
  }
  .mr32{
    margin-right: 32px
  }
  .print-table {
    width: 100%;
    text-align: left;
    border-collapse: collapse;
    border-spacing: 0;
    td,
    th {
      padding: 0 2px;
      border: 1px solid;
      overflow: hidden;
      white-space: nowrap;
    }
    thead {
      th,
      td {
        font-size: 12px;
        font-weight: normal;
        text-align: center;
      }
    }
    tbody {
      td {
        font-size: 12px;
        text-align: left;
        padding: 0 2px;
        span {
          font-size: 12px;
          word-break: break-all;
          &.small {
            transform: scale(0.6) translateX(0);
          }
        }
      }
    }
    .range {
      display: inline-block;
      min-width: 50px;
      max-width: 160px;
      white-space: nowrap;    /* 先设置为强制不换行 */
      text-overflow: ellipsis;    /* 超出设为为省略号 */
      overflow: hidden;           /* 超出隐藏 */
    }
    .text-right {
      padding-right: 8px;
      text-align: right;
    }
  }
</style>
